import { useQuery } from 'jsonapi-react'

import { Events } from 'components/Events'
import { Body } from 'layouts/basic'


export default function SceneEvents() {
  const { data: events = [], isLoading } = useQuery([
    'events',
    {
      include: 'created_by,image',
      sort: '-created_at',
    }
  ])

  return (
    <Body loading={isLoading}>
      <Events
        loading={isLoading}
        dateClassName='-top-1'
        items={events}
      />
    </Body>
  )
}
